import React, { useState } from "react";
import DashboardSide from "../dashboard/DashboardSide";
import CheckoutCenter from "./CheckoutCenter";
import MobileMenu from "../dashboard/MobileMenu";

export default function Checkout() {
  const [modal, setModal] = useState(false);
  return (
    <div className="h-full bg-[#f6f6f6] flex items-center justify-center">
      <DashboardSide />
      {modal && <MobileMenu setModal={setModal} />}
      <CheckoutCenter setModal={setModal} />
    </div>
  );
}
